export default __webpack_public_path__ + "static/media/fondoInfo.a52e3227.png";